import { s as styleInject } from './style-inject.es-1f59c1d0.js';
import { t as theme } from './theme-0fe3bd9d.js';

var css_248z = ".spring-card{--tw-shadow:0 10px 20px 0px rgba(91,89,193,.11);border-radius:15px;box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);box-shadow:inset 0 0 0 4px #fff,0 10px 20px 0 rgba(91,89,193,.11);min-height:100px;padding:4px;position:relative}.spring-card__badge{--tw-bg-opacity:1;--tw-shadow:0 3px 6px rgba(115,120,216,.15);-ms-flex-align:center;-ms-flex-pack:center;--tw-shadow:0 10px 20px 0px rgba(91,89,193,.11);-webkit-align-items:center;align-items:center;background-color:rgba(255,255,255,var(--tw-bg-opacity));border-radius:9999px;box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);display:-webkit-flex;display:-ms-flexbox;display:flex;height:50px;-webkit-justify-content:center;justify-content:center;position:absolute;top:-20px;width:50px}.spring-card__badge--left{left:-10px}.spring-card__badge--right{right:-10px}.spring-card__icon{max-height:100%}.spring-card__content{font-family:open-sans,Arial,sans-serif;font-size:16px;line-height:24px;padding:30px}@media (min-width:600px){.spring-card__content{padding-bottom:25px;padding-top:25px}}";
styleInject(css_248z);

var SpringCard = {
  render: function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "spring-card",
      class: _vm.backgroundColor
    }, [_vm.badge ? _c('div', {
      staticClass: "spring-card__badge",
      class: _vm.badgeStyles
    }, [_c('img', {
      staticClass: "spring-card__icon",
      attrs: {
        "src": _vm.badge
      }
    })]) : _vm._e(), _vm._v(" "), _vm.$slots.content ? _c('div', {
      staticClass: "spring-card__content"
    }, [_vm._t("content")], 2) : _vm._e(), _vm._v(" "), _vm._t("default")], 2);
  },
  staticRenderFns: [],
  name: 'SpringCard',
  mixins: [theme],
  props: {
    badge: {
      type: String,
      default: undefined
    },
    badgeSide: {
      type: String,
      validator(side) {
        return ['left', 'right'].includes(side);
      },
      default: 'left'
    }
  },
  computed: {
    badgeStyles() {
      return {
        'spring-card__badge--left': this.badgeSide === 'left',
        'spring-card__badge--right': this.badgeSide === 'right'
      };
    },
    backgroundColor() {
      return this.theme ? this.bgColorClass(50) : 'bg-gray-50';
    }
  }
};

export { SpringCard as S };
